import React, { useEffect, useState } from "react";
import api, { inr } from "@/lib/api";
import { Link } from "react-router-dom";
import AccountSidebar from "@/components/account/AccountSidebar";

export default function MyOrders() {
  const [orders, setOrders] = useState([]);
  useEffect(() => { api.get("/orders/my").then(r => setOrders(r.data)); }, []);
  return (
    <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 grid lg:grid-cols-[240px_1fr] gap-6">
      <AccountSidebar/>
      <section>
        <h1 className="font-display text-2xl font-bold mb-4">My Orders</h1>
        {orders.length === 0 ? <div className="bg-slate-50 rounded-2xl p-10 text-center text-slate-500">No orders yet.</div> : (
          <div className="space-y-3">
            {orders.map(o => (
              <Link key={o.order_id} data-testid={`order-${o.order_id}`} to={`/account/orders/${o.order_id}`} className="block bg-white border border-slate-100 rounded-2xl p-4 hover:border-slate-300">
                <div className="flex items-center justify-between gap-3 flex-wrap">
                  <div>
                    <div className="text-xs text-slate-500 font-mono">{o.order_id}</div>
                    <div className="font-semibold mt-1">{o.items?.length} items · {inr(o.total)}</div>
                    <div className="text-xs text-slate-500 mt-1">{new Date(o.created_at).toLocaleString()}</div>
                  </div>
                  <span className={`text-xs font-semibold px-3 py-1 rounded-full ${o.status==="Delivered"?"bg-emerald-50 text-emerald-700":o.status==="Cancelled"?"bg-red-50 text-red-700":"bg-blue-50 text-[#004BCA]"}`}>{o.status}</span>
                </div>
                <div className="flex gap-2 mt-3 overflow-x-auto scrollbar-hide">
                  {o.items?.slice(0,5).map((it,i) => <img key={i} src={it.image} className="w-14 h-14 rounded-lg object-cover shrink-0" alt=""/>)}
                </div>
              </Link>
            ))}
          </div>
        )}
      </section>
    </main>
  );
}
